import { useEffect } from 'react';

const SITE_URL = 'https://www.sarkariresult.cloud';
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.png?v=2`;

/**
 * SEO Head - Dynamic title, meta description, canonical, OG, Twitter, JSON-LD.
 */
export function SeoHead({ title, description, keywords, schema, canonical, image }) {
  useEffect(() => {
    if (title) document.title = title;

    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (description) {
      const content = description.slice(0, 160);
      if (metaDesc) metaDesc.setAttribute('content', content);
      else {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        metaDesc.content = content;
        document.head.appendChild(metaDesc);
      }
    }


    // Meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (keywords) {
      if (metaKeywords) metaKeywords.setAttribute('content', keywords);
      else {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        metaKeywords.content = keywords;
        document.head.appendChild(metaKeywords);
      }
    } else if (metaKeywords) {
      metaKeywords.parentNode.removeChild(metaKeywords);
    }

    // Canonical (avoid hash/query for clean URL)
    const canonicalUrl = canonical || (typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname || '/'}` : SITE_URL);
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (linkCanonical) linkCanonical.setAttribute('href', canonicalUrl);
    else {
      linkCanonical = document.createElement('link');
      linkCanonical.rel = 'canonical';
      linkCanonical.href = canonicalUrl;
      document.head.appendChild(linkCanonical);
    }

    // Open Graph
    const ogImage = image || DEFAULT_OG_IMAGE;
    const setMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (el) el.setAttribute('content', content);
      else {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        el.content = content;
        document.head.appendChild(el);
      }
    };
    if (title) setMeta('og:title', title, true);
    if (description) setMeta('og:description', description.slice(0, 160), true);
    setMeta('og:url', canonicalUrl, true);
    setMeta('og:image', ogImage.startsWith('http') ? ogImage : `${SITE_URL}${ogImage}`, true);
    setMeta('og:type', 'website', true);

    // Twitter Card
    setMeta('twitter:card', 'summary_large_image');
    if (title) setMeta('twitter:title', title);
    if (description) setMeta('twitter:description', description.slice(0, 160));

    // JSON-LD schema
    let schemaEl = null;
    if (schema) {
      schemaEl = document.createElement('script');
      schemaEl.type = 'application/ld+json';
      const output = typeof schema === 'string' ? schema
        : Array.isArray(schema) ? JSON.stringify({ '@context': 'https://schema.org', '@graph': schema })
        : JSON.stringify(schema);
      schemaEl.textContent = output;
      schemaEl.id = 'dynamic-seo-schema';
      document.head.appendChild(schemaEl);
    }

    return () => {
      if (schemaEl && schemaEl.parentNode) schemaEl.parentNode.removeChild(schemaEl);
    };
  }, [title, description, keywords, schema, canonical, image]);
  return null;
}
